/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import { ui } from "./ui/index";
import { IState } from "@/interfaces/IState";
import { toast } from "@/store/toast";
import { lesson } from "@/store/lesson";
import { evaluation } from '@/store/evaluation';
import { modal } from "@/store/modal";
import { user } from "@/store/user";
import { activity } from "@/store/activity";
import { pagination } from "@/store/pagination";
import { resource } from "@/store/resource";
import { progress } from "@/store/progress";
import { quiz } from "@/store/quiz";
import createPersistedState from "vuex-persistedstate";
import { task } from './task/index';
import { pdf } from "./pdf";

Vue.use(Vuex);

export default new Vuex.Store<IState>({
  modules: {
    ui: ui,
    toast: toast,
    lesson,
    modal,
    user,
    activity,
    pagination,
    resource,
    evaluation,
    quiz,
    progress,
    task,
    pdf
  },
  plugins: [createPersistedState()]
});
